import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Logger, QUERY_PARAMS, getAllWorkspacesData, workspacesSelector } from '@futrli/shared-services';
import { WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { StoreState } from '../../core/redux-utils/types';

export const useSelectAndLoadWorkspaces = () => {
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(location.search);
  const workspaceId = searchParams.get(QUERY_PARAMS.WORKSPACE_ID);

  const workspaces = useSelector((state: StoreState) => {
    if (!workspaceId) {
      return null;
    }
    const { normalised } = state;

    const workspaces = workspacesSelector(normalised) as WorkspacesListingItem[];

    return workspaces;
  });

  const [isLoading, setIsLoading] = useState(!workspaces);

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        setIsLoading(true);
        await dispatch(getAllWorkspacesData());
      } catch (e) {
        Logger.error(e as string);
      } finally {
        setIsLoading(false);
      }
    };

    if (!workspaces) {
      fetchWorkspaces();
    }
  }, [dispatch, workspaces]);

  return {
    isLoading,
    workspaces
  };
};
